import { EXPORT_STATUS } from './api';

export const ExportStatusMessage = ({ statusId }: { statusId?: number }) => {
  switch (statusId) {
    case EXPORT_STATUS.PLANNED:
      return <>Запланирован экспорт</>;
    case EXPORT_STATUS.IN_PROGRESS:
      return (
        <>
          <i className="fa fa-spinner fa-spin" /> Идет формирование экспорта
        </>
      );
    case EXPORT_STATUS.FAILED:
      return <>Произошла ошибка. Попробуйте позже еще раз!</>;
    case EXPORT_STATUS.CANCELLED:
      return <>Отменена пользователем</>;
    default:
      return null;
  }
};
